function Manufacturer ($, $description, $list) {
  const name = $.dataset.manufacturerName.toUpperCase()
  const subtitle = $.dataset.manufacturerSubtitle
  const description = $.dataset.manufacturerDescription

  const $title = document.createElement('p')
  $title.textContent = name + (subtitle && subtitle.length > 0 ? ' — ' + subtitle : '')

  const $desc = document.createElement('p')
  $desc.textContent = description

  if (name !== 'CINIER') {
    $desc.style.maxWidth = '483px'
  }

  $.addEventListener('mouseover', onOver)
  $.addEventListener('mouseout', onOut)

  function onOver () {
    for (let i = 0; i < $list.length; i++) {
      if ($list[i] === $) continue
      $list[i].classList.add('faded')
    }
    $description.appendChild($title)
    $description.appendChild($desc)
  }

  function onOut () {
    for (let i = 0; i < $list.length; i++) {
      $list[i].classList.remove('faded')
    }
    $description.removeChild($title)
    $description.removeChild($desc)
  }
}

export default Manufacturer



// WEBPACK FOOTER //
// ./src/js/components/Manufacturer.js